var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socket-item",class:( _obj = {}, _obj[_vm.snakeCase(_vm.socket.name)] = true, _obj['selected-socket'] =  _vm.socket.selected, _obj['disabled-socket'] =  _vm.socket.disabled, _obj )},[_c('transition',{attrs:{"name":"default-hide"}},[(!_vm.socket.hasConnections)?_c('div',{staticClass:"socket-item socket-center"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }